<template>
  <div>
      <nav v-if="showMenu" class="sidebar sidebar-offcanvas" id="sidebar">
        <div v-if="trialBar" class="trialbar">

            <div class="col-sm-12 col-md-6">
                <span class="d-none d-md-inline">{{ $t('last_days_of_your_trial_first_part') }}</span>

                {{ this.daysRemaining }}

                {{ $t('last_days_of_your_trial') }}
                <a href="#" class="ml-md-3 ml-sm-0 mb-sm-4 mb-md-0 mt-2 mt-md-0 d-inline-block btn btn-secondary btn-sm position-md-absolute" @click.prevent="openPayModal(1)">
                    {{ $t('buy_onboardio') }}
                </a>
            </div>
            <!--
            <div class="d-none d-md-block col-sm-12 col-md-6 text-right">
                <app-icon :name="'eye'" width="20" height="20"/>
                {{ $t('viewing_sample_data') }}

                <a href="#" class="ml-3 d-inline btn btn-secondary btn-sm" @click.prevent="openDeleteDemoModal()">
                    {{ $t('clear_data_and_add_your_own') }}
                </a>
            </div>
            <div class="d-block d-md-none col-sm-12 col-md-6 mt-2">
                <a href="#" class="mb-2 d-inline-block" @click.prevent="openDeleteDemoModal()">
                    <b>{{ $t('clear_data_and_add_your_own') }}</b>
                </a>
            </div>
            -->
        </div>


        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a class="navbar-brand brand-logo" href="/admin/dashboard">
            <img src="/images/logo.svg" alt="Onboardio"/>
          </a>
          <a class="navbar-brand brand-logo-mini" href="/admin/dashboard">
            <img src="/images/logo.svg" alt="Onboardio"/>
          </a>
        </div>


        <ul class="nav nav-scrolling">
            <div class="underline"></div>
            <div class="underline"></div>
            <div class="underline"></div>

          <li class="nav-item nav-item-group" :class="item.class +' '+ item.menu" :data-href="item.url" :data-underline="item.menu == 'nav-item-underline' ? index : false" v-for="(item, index) in data" :key="index" v-if="item.permission" @mousedown="item.menu == 'nav-item-underline' ? applyCurrentUnderline(index) : false">
            <a class="nav-link"
               :href="item.id ? '#'+item.id : item.url"
               :data-toggle="item.id ? 'collapse' : false"
               :aria-expanded="item.id ? 'false' : false"
               :aria-controls="item.id ? item.id : false">

              <span class="menu-title">{{ item.name }}</span>
              <i v-if="item.subMenu" class="menu-arrow"/>
            </a>

            <div class="collapse" v-if="item.subMenu" :id="item.id">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"
                    v-for="(submenuItem, index) in item.subMenu"
                    :key="index"
                    v-if="submenuItem.permission === true || submenuItem.permission === ''">
                  <a class="nav-link" :href="submenuItem.url">
                      <span class="icon-wrapper">
                          <i :class="'custom-icon-'+submenuItem.icon" class="custom-icon"></i>
                          <!--
                          <img src="/images/lordicon/system-regular-19-book.apng" width="30">


                          <app-icon :name="item.icon" class="menu-icon"/>
                          -->
                      </span>

                    <span class="nav-link-title">{{ submenuItem.name }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>



        </nav>
        <app-pay-modal
                v-if="payModalActive"
                modal-id="pay-modal"
                modal-size="large"
                modal-alignment="top"
                @close-modal="closePayModal"
        />
         <app-delete-demo-modal
                v-if="deleteDemoModalActive"
                modal-id="delete-demo-modal"
                modal-size="small"
                modal-alignment="top"
                @close-modal="closeDeleteDemoModal"
        />
    </div>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";

export default {
  name: "Sidebar",
  props: {
    data: {
      type: Array,
      required: true
    },
    logoSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/core.png'),
    },
    logoIconSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/core.png'),
    },
    logoUrl: {
      type: String,
      default: '/'
    }
  },
  data() {
        return {
            payModalActive: false,
            deleteDemoModalActive: false,
            trialBar: false,
            showMenu: true,

        }
  },
  created() {
    this.checkPermissions();
  },
  methods: {
      checkPermissions(){
        let userData = data;
        let permissions = 0;
        for (let i = 0; i < userData.length; i++) {
          if(userData[i].permission){
            permissions++;
          }
        }
        if(userData.length && permissions == 0){
          this.showMenu = false;
        }
      },

      /**
      * for open modal
      */
      openPayModal(id) {
        this.payModalActive = true;

        // link to buy a membership
        if (history.pushState && id == 1) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?pay=1';
            window.history.pushState({path:newurl},'',newurl);
        }

      },
      openDeleteDemoModal() {
        this.deleteDemoModalActive = true;
      },
      getUrlParameter(name, url) {
        if (!url) url = location.href;
        name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
        var regexS = "[\\?&]"+name+"=([^&#]*)";
        var regex = new RegExp( regexS );
        var results = regex.exec( url );
        return results == null ? null : results[1];
      },
      getDefaultPay(){
        let selectedModule = '';

        if(location.href.indexOf("?pay") >= 0){
            selectedModule = parseInt(this.getUrlParameter('pay', location.href));
        }

        return selectedModule;
      },
      isMembershipPaid() {
          this.trialBar = false;
          this.daysRemaining = 30;
          // lock with button pay
      },

      /**
      * for close modal
      */
      closePayModal() {
          this.payModalActive = false;

          // link to buy a module
          if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '';
                window.history.pushState({path:newurl},'',newurl);
          }
      },
      closeDeleteDemoModal() {
          this.deleteDemoModalActive = false;
      },

      applyDefaultUnderline(clicked) {
        let nav_width = $('.nav').width();
        let underline_total_width = 0;
        let current = location.pathname;
        let underline_width = 0;
        let underlineTransition = 'none';
        let underline_current_item = $('.nav-item-underline[data-href="'+current+'"]');

        if(clicked){
            underline_current_item = $('.nav-item-underline[data-underline="'+clicked+'"]');
            underlineTransition = '';
        }

        if(underline_current_item.length > 0){
            underline_width = underline_current_item.innerWidth();
        }

        $('.sidebar .nav-item-underline').each(function(index) {
            underline_total_width += parseInt($(this).innerWidth(), 10);
        });

        let underline_start = (nav_width-underline_total_width)/2;
        let underline_position = underline_start;

        if(underline_current_item.data("underline") == '2'){
            underline_position += $('.sidebar .nav-item[data-underline="1"]').innerWidth();
        }
        if(underline_current_item.data("underline") == '3'){
            underline_position += $('.sidebar .nav-item[data-underline="2"]').innerWidth()+$('.sidebar .nav-item[data-underline="1"]').innerWidth();
        }
        if(underline_current_item.data("underline") == '4'){
            underline_position += $('.sidebar .nav-item[data-underline="3"]').innerWidth()+$('.sidebar .nav-item[data-underline="2"]').innerWidth()+$('.sidebar .nav-item[data-underline="1"]').innerWidth();
        }

        var underlines = document.querySelectorAll(".underline");
        for (var i = 0; i < underlines.length; i++) {
            underlines[i].style.transition = underlineTransition;
            underlines[i].style.transform = 'translate3d(' + underline_position + 'px,0,0)';
            underlines[i].style.width = underline_width+'px';
        }
    },
    applyCurrentUnderline(index){
        this.applyDefaultUnderline(index);

        $('.sidebar .nav-item').removeClass('active');
        $('.sidebar .nav-item[data-underline="'+index+'"]').addClass('active');

        $('.sidebar .nav-item').find('i').removeClass('active');
        $('.sidebar .nav-item[data-underline="'+index+'"]').find('i').addClass('active');
    },
    resizeCurrentUnderline(){
        let index = $('.sidebar .nav-item.active').data("underline");
        this.applyDefaultUnderline(index);
    },

  },
  created() {
      // Welcome message
      console.log("AHOY! Zajímá tě podpalubí Onboardia? Připoj se k nám, hledáme posily do týmu: https://onboardio.cz/kontakt.html");

      // Trial pay bar
      this.isMembershipPaid();

      window.addEventListener("resize", this.resizeCurrentUnderline);



      let smartsupp = document.createElement('script');
      smartsupp.setAttribute('src',"/js/smartsupp.js");
      document.head.appendChild(smartsupp);


  },
  destroyed() {
      window.removeEventListener("resize", this.resizeCurrentUnderline);
  },
  mounted() {
    this.$nextTick(function () {
      let body = $('body'),
          current = location.pathname,
          sidebar = $('.sidebar'),
          sidebarType = localStorage.getItem('sidebar');


      // Animated underline
      if(current == '/careersite'){
          this.applyDefaultUnderline(1);
      } else if(current == '/onboarding/checklist'){
          this.applyDefaultUnderline(4);
      } else if(current.indexOf('/onboarding/stranka') !== -1 ){
          this.applyDefaultUnderline(4);
          $('.nav-item[data-underline="4"]').addClass('active');
      } else {
          this.applyDefaultUnderline();
      }



      $(function () {
        // Add active class to nav-link based on url dynamically
        function addActiveClass(element) {
          if ((current != "/onboarding" && element.attr('href').indexOf(current) !== -1) || (current == "/onboarding" && element.attr('href') == current)) {

            element.parents('.nav-item').last().addClass('active');
            element.parents('.nav-item').last().find('.custom-icon').addClass('active');

            if (sidebarType === 'floating') {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').removeClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            } else if (sidebarType === 'icon-only') {
              $('#hiring.collapse, #onboarding.collapse').addClass('show');
            } else {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').addClass('show');

                if(element.attr('href').indexOf('/onboarding/') !== -1){
                    element.addClass('active');
                } else if(element.attr('href').indexOf('/onboarding') !== -1){
                    element.addClass('active');
                } else {
                    element.addClass('active');
                }

              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            }

              element.find('.custom-icon').addClass('active');

          }
        }

        $('.nav li a', sidebar).each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        $('.horizontal-menu .nav li a').each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        // Close other submenu in sidebar on opening any
        sidebar.on('show.bs.collapse', '.collapse', function () {
          sidebar.find('.collapse.show').collapse('hide');
        });

        // Change sidebar and content-wrapper height
        applyStyles();

        function applyStyles() {
          //Applying perfect scrollbar
          if (!body.hasClass("rtl")) {
            if (body.hasClass("sidebar-fixed")) {
              let fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav');
            }
          }
        }
      });






      // Sidebar collapse menu on hover
      $(document).on('mouseenter mouseleave click', '.sidebar .nav-item', function (ev) {
        let body = $('body');
        let sidebarIconOnly = body.hasClass("sidebar-icon-only");
        let sidebarFixed = body.hasClass("sidebar-fixed");

        if (sidebarIconOnly) {
          if (sidebarFixed) {
            if (ev.type === 'mouseenter') {
              //body.removeClass('sidebar-icon-only');
            }
          } else {
            let $menuItem = $(this);
            if (ev.type === 'mouseenter') {
              $menuItem.addClass('hover-open')
            } else if (ev.type === 'click') {
              $menuItem.addClass('hover-open')
            } else {
              $menuItem.removeClass('hover-open')
            }
          }
        }
      });

      // Close collapse menu when mouse leave from sidebar hover only
      $(document).on('mouseenter mouseleave', '.sidebar-hover-only .sidebar', function (ev) {
        if (ev.type === 'mouseleave') {
          $('.sidebar').find('.collapse.show').collapse('hide');
        } else {

        }
      });
    });



    /**
     * for open modal after clicking on "I want this" module
     */
    if(this.getDefaultPay()){
        this.selectedUrl = `${this.getDefaultPay()}`;
        this.openPayModal();
    }
  }
}
</script>
